<div class="col-sm-12 company-results div-imbrication"
     *ngIf="(tsCompany && tsCompany.editingMode !== 'addition') && (tsCompany.editingMode !== 'edition')">
    <div class="row">
        <div class="col-sm-9">
            <input (ngModelChange)="toggleRegistrationCompany(tsCompany)"
                   [(ngModel)]="tsCompany.selected"
                   [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
                   aria-label="checkbox-trainer" *jhiHasAnyAuthority="'ROLE_ADMIN'">

            <span class="company-name">{{tsCompany.name}}</span>
            <span *ngIf="salesPersonName(tsCompany)" class="faded-text"> - {{salesPersonName(tsCompany)}} -</span>
            <span class="faded-text">{{ displayBillingMode(tsCompany) | translate }}</span> / <span class="faded-text">{{ displayFinancing(tsCompany) | translate }}</span>
        </div>
        <div class="col-sm-2 actions">
            <span class="dropdown more-actions" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                <i class="fa fa-ellipsis-h on fa-circle"
                   type="button" id="more-menu-company" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></i>
                <span class="dropdown-menu" aria-labelledby="more-menu-company">
                    <li>
                        <a class="dropdown-item" (click)="companyEdition('edition')">
                            <i class="fa fa-fw fa-pencil"></i> Modifier</a>
                    </li>
                    <li>
                        <a class="dropdown-item" (click)="openDeleteModal(deleteModal)"><i
                                class="fa fa-fw fa-trash"></i> Supprimer</a>
                    </li>
                </span>
            </span>
            &nbsp;&nbsp;
            <span (click)="addContact()" *jhiHasAnyAuthority="'ROLE_ADMIN'"><i class="fa fa-fw fa-plus-circle"></i>Contact</span>
        </div>
        <div class="col-sm-1 text-right">
            <span class="company-price">&nbsp;{{getCompanyPrice(tsCompany)}}</span>
        </div>
    </div>
</div>

<div class="col-sm-12 registration-edition registration-edition-company"
     *ngIf="(tsCompany && tsCompany.editingMode === 'addition') || (tsCompany.editingMode === 'edition') ">
    <div class="row">
        <div class="col-sm-10">
            <registration-company-edition [tsCompany]="tsCompany"
                                          [editingMode]="tsCompany.editingMode"
                                          (getCompany)="getNewCompany($event)"
                                          (getCurrency)="getCurrency($event)"
                                          (getPrice)="getPrice($event)"
                                          (getType)="getType($event)"
                                          class="registration-block">
            </registration-company-edition>
        </div>
        <div class="col-sm-2 text-right actions">
            <button class="btn btn-primary btn-sm"
                    [disabled]="isDisabled(tsCompany, price, billingMode)"
                    (click)="confirmChanges(tsCompany)">
                <i class="fa fa-fw fa-check"></i>
            </button>
            <button class="btn btn-default btn-sm"
                    (click)="cancel(tsCompany)">
                <i class="fa fa-fw fa-ban"></i>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-10">
            <div class="col-sm-4">
                <input class="form-control input-sm" id="orderNumber" [placeholder]="'session-details.student-tab.orderNumberPlaceholder' | translate" type="text" [(ngModel)]="tsCompany.orderNumber">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-10">
            <registration-sales-person-edition
                [tsCompany]="tsCompany"
            >
            </registration-sales-person-edition>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-10">
            <registration-financing-edition
                [tsCompany]="tsCompany"
            >
            </registration-financing-edition>
        </div>
    </div>
</div>

<!--Contacts-->
<div class="col-sm-12 contacts-block" *ngIf="tsCompany">
    <div *ngFor="let tsContact of tsCompany.contacts; let i = index">
        <registration-contact [tsCompanies]="tsCompanies"
                              [tsCompany]="tsCompany"
                              [tsContacts]="tsCompany.contacts"
                              [tsContact]="tsContact"
                              [newRegistration]="newRegistration"
                              [session]="session">
        </registration-contact>
    </div>
</div>

<div class="col-sm-12 contacts-block"  *ngIf="tsCompany">
    <div *ngIf="showCreateContactPanel">
        <registration-contact (create)="tsContactCreated($event)"
                              [tsCompany]="tsCompany"
                              [session]="session">
        </registration-contact>
    </div>
</div>

<!--Modals-->
<ng-template #deleteModal>
    <div class="modal-header">
        <h4 class="modal-title">Êtes-vous sur de vouloir supprimer cette entreprise ET tous les stagiaires associés
            ?</h4>
    </div>
    <div class="modal-footer">
        <button style="margin-bottom: 0px" type="button" class="btn btn-default" (click)="closeDeleteModal()">Annuler
        </button>
        <button type="button" class="btn btn-primary" (click)="deleteCurrentEditingOption()">Supprimer</button>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-company.component.html